import React, {
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { getEmployeeAwards } from "../../AwardList/Services/awardService";
import { getTrans as T } from "../../../../Shared/Language";
import { TostMsg } from "../../../../App";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import ERROR_LIST from "../../../../Services/Global-Services/Hadle_Errors";
import moment from "moment";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
const defaultImage = "/images/placeholder_profile.png";
const defaultAwardImage = "/images/no-data-found/Award_dummy.svg";
const Award = () => {
  const [Isloading, setIsloading] = useState(true);
  const [awardList, setAwardList] = useState([]);
  const toster = useContext(TostMsg);
  const [carouselKey, setCarouselKey] = useState(0);
  const history = useHistory();
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    await getAwardList();
  };

  //Get the Employee Awards List.
  async function getAwardList() {
    setIsloading(true);
    const params = {
      LoggedInUserId: 0,
      year: "",
      Awardid: 0,
      PageNumber: 1,
      AwardNumber: "",
      PageSize: 6,
      OrgId: userDetails.OrgId,
    };
    try {
      const response = await getEmployeeAwards(params);
      setCarouselKey((prevKey) => prevKey + 1);
      setAwardList(response.Data);
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
      toster.current.error(ERROR_LIST.DashboardAward);
    }
  }
  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  const handleAwardImageError = useCallback((event) => {
    event.target.src = defaultAwardImage;
  }, []);

  const navigatePage = (event) => {
    history.push(`/Award/Detail/${event?.AwardNumber}`);
  }

  return (
    <div className="col-xl-12 owl-co owl-co2 col-sm-6 col-md-12">
      <div className="card award">
        <div className="card-body">
          <div className="custom-tab-1 custom-tab-11">
            <div className="">
              <strong className="upcome">{T("Awards")}</strong>
              <Link to="/Awards" className="more-icon">
                <i className="fa fa-angle-right"></i>
              </Link>
              {Isloading ? (
                <Skeleton height={100} width="100%" style={{ marginBottom: "15px" }}/>
              ) : (
                <div className="boxs boxs2">
                  {awardList.length == 1 ? awardList?.map((awards, index) => (
                    <div onClick={() => navigatePage(awards)} className="item" key={index}>
                      <div className="image-content">
                        <img
                          className="img"
                          src={awards?.EmployeeProfileImage || defaultImage}
                          onError={handleImageError}
                          alt=''
                        />
                        <div className="pos-img">
                          <img
                            src={awards?.awardImage || defaultAwardImage}
                            onError={handleAwardImageError}
                            alt=''
                          />
                        </div>
                      </div>
                      <p className="detailed-p-text">
                        {awards?.EmployeeName} </p>
                      <p className="detailed-span-text">{awards?.AwardName}</p>
                      <span className="b-color">
                        {moment(awards?.Date).format("MMM DD YYYY")}
                      </span>
                    </div>
                  )) : <OwlCarousel
                    key={carouselKey}
                    items={2}
                    className="owl-theme"
                    loop
                    autoplay={true}
                    autoplayTimeout={3000}
                    autoplayHoverPause={true}
                    nav={false}
                    dots={true}
                    margin={8}
                  >
                    {awardList?.map((awards, index) => (
                      <div onClick={() => navigatePage(awards)} className="item" key={index}>
                        <div className="image-content">
                          <img
                            className="img"
                            src={awards?.EmployeeProfileImage || defaultImage}
                            onError={handleImageError}
                            alt=''
                          />
                          <div className="pos-img">
                            <img
                              src={awards?.awardImage || defaultAwardImage}
                              onError={handleAwardImageError}
                              alt=''
                            />
                          </div>
                        </div>
                        <p className="detailed-p-text">
                          {awards?.EmployeeName} </p>
                        <p className="detailed-span-text">{awards?.AwardName}</p>
                        <span className="b-color">
                          {moment(awards?.Date).format("MMM DD YYYY")}
                        </span>
                      </div>
                    ))}
                  </OwlCarousel>}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Award;